module.exports = __webpack_public_path__ + "img/illus_tutorial_0.65457370.png";